export const SET_USERS = 'adminUsers/SET_USERS'
export const CLEAN_ALERT_MESSAGES = 'adminUsers/CLEAN_ALERT_MESSAGES'
export const ADD_ERRORS = 'adminUsers/ADD_ERRORS'
export const CHANGE_PAGE = 'adminUsers/CHANGE_PAGE'
export const SET_SEARCH_TERM = 'adminUsers/SET_SEARCH_TERM'
export const SET_USER_OPTIONS = 'adminUsers/SET_USER_OPTIONS'
